import { DataQueryParams } from 'common/src/query-params/DataQueryParams';
import type { IOrganizationGroup, IPage } from 'common/src/types/interfaces';

import { API_BASE_PATHS } from 'portal/src/api/constants';
import formatQueryParams from 'portal/src/api/formatQueryParams';
import {
  deleteRequest,
  getRequest,
  patchRequest,
  postRequest,
} from 'portal/src/api/requestTypes';

export const getOrganizationGroups = async (
  params: DataQueryParams = {},
): Promise<IPage<IOrganizationGroup>> =>
  await getRequest(
    API_BASE_PATHS.ORGANIZATION_GROUPS,
    formatQueryParams(params),
  );

export const addOrganizationGroup = async (body: any) =>
  await postRequest(API_BASE_PATHS.ORGANIZATION_GROUPS, {}, body);

export const updateOrganizationGroup = async (id: string, body: any) =>
  await patchRequest(`${API_BASE_PATHS.ORGANIZATION_GROUPS}/${id}`, {}, body);

export const deleteOrganizationGroup = async (id: string): Promise<void> =>
  await deleteRequest(`${API_BASE_PATHS.ORGANIZATION_GROUPS}/${id}`);
